import React from "react";

export const SectionControlForm = (props) => {
  return (
    <section className="d-flex">
      <form className="bg-light w-100">
        <div className="sideb">
          <h3 className="text-center p-3">Filter By</h3>
          <div className="form-group">
            <h4>Price</h4>
            <p>Minimum:</p>
            <input
              aria-label="minimum price in USD"
              className="form-check-plaintext"
              type="number"
              value={props.minPrice}
              id="form-price-min"
              placeholder="Min price, (ex. 20)"
              onChange={(e) => props.minPriceCallback(e.target.value)}
            />
            <p>Maximum:</p>
            <input
              aria-label="maximum price in USD"
              className="form-check-plaintext"
              type="number"
              value={props.maxPrice}
              id="form-price-max"
              placeholder="Max price, (ex. 100)"
              onChange={(e) => props.maxPriceCallback(e.target.value)}
            />
            <div className="form-group mt-3">
              <h4>Thumbs Ups</h4>
              <p>Minimum:</p>
              <input
                aria-label="Minimum thumbs up"
                className="form-check-plaintext"
                type="number"
                value={props.minThumbs}
                id="form-thumbs-min"
                placeholder="Minimum thumbs up"
                onChange={(e) => props.minThumbsCallback(e.target.value)}
              />
            </div>
          </div>
        </div>
      </form>
    </section>
  );
};
